// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1unnw","itemTitle":"ClientEmergencyInfo_itemTitle__1fdQi","itemText":"ClientEmergencyInfo_itemText__1zTyI"};